export default __webpack_public_path__ + "static/media/music_1.595bb777.mp4";